import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { useParams } from 'react-router-dom';
import { deleteCaseConstructionLegalityDocumentQuery } from 'app/edozvola/cases/case-construction-legality/service/case-construction-legality.queries';

export interface ICaseConstructionLegalityDocumentsDeleteModal {
  documentWebId: string;
  isModalOpen: boolean;
  closeModalCallback: Function;
}

const CaseConstructionLegalityDocumentsDeleteModal = (props: ICaseConstructionLegalityDocumentsDeleteModal) => {
  const { id } = useParams<{ id: string }>();

  const { mutate: deleteMutation } = deleteCaseConstructionLegalityDocumentQuery(id, props.closeModalCallback);

  return (
    <Modal scrollable isOpen={props.isModalOpen} size={'lg'} toggle={() => props.closeModalCallback()} centered>
      <ModalHeader>
        <span>Brisanje akta</span>
      </ModalHeader>
      <ModalBody>
        <div>Jeste li sigurni da želite obrisati podatke?</div>
      </ModalBody>
      <ModalFooter>
        <Button size={'lg'} label="Odustani" onClick={() => props.closeModalCallback()} />
        <Button size={'lg'} label="Obriši" color={'danger'} onClick={() => deleteMutation(props.documentWebId)} />
      </ModalFooter>
    </Modal>
  );
};

export default CaseConstructionLegalityDocumentsDeleteModal;
